'use client';
import { useWatchAccount } from '@/lib/hooks/walletHooks/useWatchAccount';
import { hasToken, switchSession, useSession } from '@/lib/hooks/useSession';
import { useSignLogin } from '@/lib/hooks/walletHooks/useSignLogin';

export function WalletAccountClient() {
  const { refetch } = useSession();
  const { signLogin } = useSignLogin();
  useWatchAccount(async (address) => {
    if (address) {
      if (hasToken(address)) {
        await switchSession(address);
        await refetch();
      } else {
      }
    }
  });
  return <></>;
}
